import { CSSProperties } from 'react';

export function AstarLogo({ size = 16, style }: { size?: number; style?: CSSProperties }) {
	return (
		<svg width={size} height={size} style={style} viewBox="0 0 2500 2500" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M2496.8 1165.2C2450 476.4 1853.8 -43.9 1165.1 2.89999C822.1 26.3 520.8 186.1 310.6 425.4L310 425C308.5 426.9 307.2 428.8 305.9 430.8C97.1 671.7 -20.4 991.7 2.89998 1334.8C5.09998 1367.6 8.89998 1399.6 13.6 1431.5C13.6 1433 14 1434.3 14.2 1435.8C17.4 1456.8 21.1 1477.8 25.1 1498.3C28.9 1517.3 33.2 1536.2 37.9 1555C182.3 2130.7 721.6 2538.4 1334.7 2496.7C2023.3 2449.9 2543.8 1853.7 2497 1164.9C2497.1 1164.8 2496.8 1165.2 2496.8 1165.2ZM2224.7 1183.8C2230.5 1268.6 2225.1 1351.6 2209.9 1431.6C2209.9 1431.2 2209.5 1430.8 2209.5 1430.3C2118.7 1208.9 1939.5 1048.9 1782 960.5C1813.9 585.3 1686.6 427 1542.4 401.3C1429.2 380 1320.2 454.6 1298.9 567.8C1298.1 571.8 1297.5 575.9 1297 580C1282.3 694.2 1362.9 798.8 1477.1 813.5C1477.3 813.5 1477.4 813.5 1477.6 813.6C1487.6 814.9 1497.5 815.3 1507.1 815.1C1507.8 828.5 1508.2 841.9 1508.2 855.3C1374.9 822.4 1250.4 815.7 1136.8 826C1094.1 828.8 1051.6 834.2 1009.5 842C1023.7 715.3 1071.3 572.9 1163.5 468.9C1252.7 368.1 1385.3 310.6 1529.9 325.4C1557.3 328.2 1586.6 335 1612.9 343.8C1614.2 344.2 1615.5 344.6 1616.6 344.8C1951.6 481.3 2198.3 799.4 2224.4 1183.8C2224.5 1183.8 2224.7 1183.8 2224.7 1183.8ZM1353.4 1374.7C1353.4 1374.7 1353.4 1374.9 1353.2 1375.1C1321.6 1420.5 1285.8 1462.9 1246.2 1501.6C1186.3 1438.3 1135.6 1367 1095.6 1289.6C1093.7 1285.5 1091.6 1281.9 1089.6 1277.8V1277.4C1066.1 1227.3 1047.4 1175 1033.6 1121.4C1122.4 1100.4 1209.4 1092.7 1292.7 1096.8L1306 1097.4H1306.4C1358.6 1101.7 1412.9 1111.3 1469.2 1126.7C1443.1 1214.5 1404.2 1298 1353.7 1374.4C1353.6 1374.5 1353.4 1374.7 1353.4 1374.7ZM926.4 327.9L925.8 328.7C779.3 517.9 730.5 753 732.6 933.5C391.6 1093.5 318.4 1282.8 368.1 1420.6C369.3 1424.5 370.9 1428.1 372.4 1431.8C416.9 1538.1 539.2 1588.3 645.6 1543.9C751.9 1499.4 802.1 1377.1 757.7 1270.7C753.8 1261.6 749.3 1252.8 744.2 1244.4C754.9 1237.3 766.5 1230.3 778.9 1223C816.9 1355 873.2 1466.5 938.9 1559.7C962.7 1595 988.3 1629 1016.3 1661.7C899.5 1712.8 752.3 1742.8 616 1715C484.2 1688.1 368.1 1602.1 308.4 1469.4C297 1443.4 288.4 1416.2 282.7 1388.4C279.2 1364.5 276.5 1340.4 274.8 1316.3C244.4 868.5 522.1 470 926.4 327.9ZM1316.2 2224.8C1050.3 2243 801.7 2152.3 613.9 1991C850.9 2023.3 1079 1948 1234.3 1855.8C1543.4 2071.2 1744.1 2040 1838.6 1928.1C1913.7 1840.6 1903.6 1708.8 1816.1 1633.7C1813 1631 1809.8 1628.5 1806.5 1626C1714.8 1556.1 1583.8 1573.8 1513.9 1665.5L1513.8 1665.6C1507.8 1673.5 1502.5 1682.1 1497.8 1690.6C1486.5 1684.8 1474.5 1678.4 1462.3 1671.3C1549.4 1581.4 1620.8 1477.6 1673.4 1364.1C1692.3 1325.7 1708.8 1286.2 1723 1245.8C1825.7 1321.6 1925.4 1433.8 1969.5 1565.8C2012.1 1693.3 1995.8 1837.1 1910.7 1955C1893.9 1977.9 1874.7 1998.9 1853.4 2017.7L1852.6 2018.5C1698.8 2139.7 1511.9 2211.5 1316.5 2224.5C1316.4 2224.6 1316.2 2224.8 1316.2 2224.8Z"
				fill="url(#paint0_linear_712_8682)"
			/>
			<path
				opacity="0.9"
				d="M1542.5 401.1C1519.1 396.6 1495 396.4 1471.5 400.3C1591.1 465.3 1678.2 646.5 1632.4 1004.2C1617.3 1120.5 1583.1 1233.6 1531.2 1338.8C1486.5 1434.8 1428.4 1524 1358.5 1603.6C1391.6 1628.5 1426.3 1651.3 1462.3 1671.9C1549.4 1582.1 1620.8 1478.2 1673.5 1364.7C1725.5 1259.5 1759.6 1146.5 1774.7 1030.1C1829.3 604.4 1695.4 428.6 1542.6 401.3L1542.5 401.1Z"
				fill="url(#paint1_radial_712_8682)"
			/>
			<path
				opacity="0.8"
				d="M1632.4 1003.9C1678.2 646.4 1591.1 465 1471.5 400C1466.8 400.6 1462.3 401.7 1457.6 402.8C1574.6 470.2 1658.9 651.1 1613.8 1003.9C1598.7 1120.2 1564.5 1233.3 1512.6 1338.5C1469.5 1431.1 1413.9 1517.4 1347.2 1594.8C1351 1597.8 1354.7 1600.6 1358.5 1603.3C1428.3 1523.6 1486.4 1434.5 1531.1 1338.5C1583.1 1233.3 1617.3 1120.3 1632.4 1003.9Z"
				fill="white"
			/>
			<path
				opacity="0.5"
				d="M1177.8 1814.9C1166.5 1806.4 1155.8 1797.4 1144.9 1788.4C968.4 1862 723.9 1908.2 480.9 1851.7C520.5 1902.4 565 1949 613.7 1991C850.7 2023.3 1078.8 1948 1234.1 1855.8C1215 1842.5 1196.2 1828.8 1177.6 1814.7L1177.8 1814.9Z"
				fill="url(#paint2_radial_712_8682)"
			/>
			<path
				opacity="0.6"
				d="M1145 1788.4C1139.7 1783.9 1134.1 1779.4 1129 1774.9C951.2 1845.9 705.4 1888.5 463 1827.9C469 1835.8 475 1843.9 481 1851.7C723.9 1908.2 968.6 1862 1145 1788.4Z"
				fill="url(#paint3_linear_712_8682)"
			/>
			<path
				opacity="0.9"
				d="M368.3 1420.9C369.5 1424.7 371.1 1428.4 372.6 1432C380.5 1450.8 390.8 1467.7 403.2 1482.9C399.8 1346.9 513.2 1180.6 845.6 1041.6C953.9 996.6 1068.9 969.7 1185.9 962C1291.4 952.6 1397.8 958.4 1501.7 979.1C1507.1 934.2 1509.2 892.3 1508.8 855.2C1387.5 824.7 1261.8 814.8 1137.2 825.9C1020.1 833.6 905.1 860.5 796.8 905.5C400.9 1071.1 315.5 1275 368.4 1421L368.3 1420.9Z"
				fill="url(#paint4_radial_712_8682)"
			/>
			<path
				opacity="0.8"
				d="M845.6 1041.8C513.2 1180.9 399.8 1347.1 403.2 1483.1C406.2 1486.7 409.4 1490.2 412.6 1493.6C412.4 1358.6 527 1195.2 855 1057.8C963.3 1012.8 1078.3 985.9 1195.3 978.2C1297 969.2 1399.6 974.2 1499.9 993.2C1500.6 988.5 1501.1 983.8 1501.6 979.1C1397.7 958.5 1291.4 952.7 1185.8 962C1068.8 969.7 953.8 996.6 845.5 1041.6C845.6 1041.6 845.6 1041.8 845.6 1041.8Z"
				fill="white"
			/>
			<path
				opacity="0.4"
				d="M1775.1 1029.8C1773.4 1043.9 1771.1 1057.6 1768.7 1071.5C1920.6 1187.5 2083 1376.3 2155.7 1614.8C2179.7 1555.1 2197.9 1493.2 2209.8 1430C2119.3 1208.6 1940 1048.7 1782.6 960.4C1780.7 982.9 1778.3 1005.8 1775.3 1029.7C1775.3 1029.8 1775.1 1029.8 1775.1 1029.8Z"
				fill="url(#paint5_radial_712_8682)"
			/>
			<path
				opacity="0.5"
				d="M1768.6 1071.5C1767.3 1078.3 1766.2 1085.4 1764.9 1092.3C1915.3 1210.8 2075.1 1402.3 2143.8 1642.5C2147.8 1633.3 2151.7 1624.1 2155.3 1614.9C2082.6 1376.4 1920.4 1187.7 1768.3 1071.5C1768.4 1071.5 1768.6 1071.5 1768.6 1071.5Z"
				fill="url(#paint6_linear_712_8682)"
			/>
			<path
				opacity="0.9"
				d="M1838.6 1927.9C1854.1 1909.7 1866.4 1889 1875 1866.7C1758.8 1937.7 1558.3 1922.5 1271.5 1704.1C1178.3 1632.9 1097.4 1546.7 1032.3 1449.1C971.4 1362.4 923.2 1267.5 889.2 1167.2C847.7 1185 810.3 1204.2 778.2 1223C812.5 1343.3 866.7 1457.1 938.6 1559.5C1002.8 1655.3 1082.8 1742 1177.8 1814.5C1519.2 2074.6 1738.5 2046.6 1838.4 1927.8L1838.6 1927.9Z"
				fill="url(#paint7_radial_712_8682)"
			/>
			<path
				opacity="0.8"
				d="M1271.7 1704.1C1558.3 1922.5 1759 1937.7 1875.1 1866.6C1876.8 1862.1 1878.3 1857.6 1879.6 1853.3C1762.8 1921.1 1563.8 1903.3 1281.1 1688C1187.9 1616.8 1107 1530.6 1041.9 1433C983.2 1349.4 936.4 1258.1 902.6 1161.7C898.1 1163.6 893.8 1165.3 889.6 1167.2C923.6 1267.5 971.8 1362.5 1032.7 1449.2C1096.9 1545 1176.9 1631.7 1271.9 1704.2L1271.7 1704.1Z"
				fill="white"
			/>
			<path
				opacity="0.3"
				d="M796.6 905.1C809.6 899.7 822.7 894.8 835.9 889.9C860.3 700.4 942.7 465.3 1113 283.2C1049.2 292.4 986.5 307.4 925.8 328.5C779.2 517.7 730.4 752.8 732.6 933.4C752.9 923.8 774.1 914.4 796.4 905.2L796.6 905.1Z"
				fill="url(#paint8_radial_712_8682)"
			/>
			<path
				opacity="0.4"
				d="M835.9 889.9C842.6 887.6 849 885 855.6 882.6C883 693 969 459 1142.5 279.3C1132.7 280.4 1122.8 281.7 1113 283C942.7 465.3 860.4 700.1 836 889.7L835.9 889.9Z"
				fill="url(#paint9_linear_712_8682)"
			/>
			<path
				opacity="0.4"
				d="M1165.1 2.99994C822 26.2999 520.8 186.1 310.6 425.5L305.9 430.8C346.7 471.5 480.7 551.5 534.8 584.8C642.7 468.6 777.2 380.4 926.8 327.9C937.3 314.2 948.4 300.7 960 287.7C1101 128.4 1293.8 44.2999 1517.5 44.2999C1542.3 44.2999 1593 48.3999 1594.1 48.3999C1454.9 8.29995 1309.7 -7.10006 1165.1 2.99994Z"
				fill="url(#paint10_linear_712_8682)"
			/>
			<path
				opacity="0.4"
				d="M1316.2 2225C1050.3 2243.2 801.7 2152.5 613.9 1991.2C596.3 1988.9 578.7 1986 561.3 1982.4C352.7 1939.8 183.3 1814.9 71.6 1621.3C59.3 1599.9 48.1 1577.9 38 1555.4C182.4 2131.1 721.7 2538.8 1334.6 2497.1C1337.4 2434 1318.8 2287.5 1316 2225H1316.2Z"
				fill="url(#paint11_linear_712_8682)"
			/>
			<path
				opacity="0.4"
				d="M2496.9 1165.2C2458.4 1161.3 2271 1176.1 2224.8 1183.8C2230.6 1268.6 2225.2 1351.6 2210 1431.6C2216.4 1447.4 2222.6 1463.7 2228.2 1480.1C2295.6 1682.1 2272.1 1891.1 2160.4 2084.9C2148 2106.3 2134.6 2127 2120.2 2147C2120.2 2147 2120.8 2146.5 2121 2146.1C2375 1899 2522.8 1546.5 2496.9 1165.5V1165.2Z"
				fill="url(#paint12_linear_712_8682)"
			/>
			<path
				opacity="0.5"
				d="M1530.4 325.2C1557.8 328 1587.1 334.8 1613.4 343.6C1614.6 344 1616 344.4 1617 344.6C1724.3 388.4 1823 450.8 1908.6 529C1908.6 529 1909 529.2 1909.2 529.4C1950.3 482.6 2029.2 431 2029.2 431C2029.2 431 1908.4 307.3 1723.3 268.8C1593.9 241.8 1301.9 216 1117.7 529.3L1119.4 527.6C1133.1 507 1147.4 486.9 1163.9 468.5C1253.1 367.9 1385.7 310.4 1530.4 325.2Z"
				fill="url(#paint13_linear_712_8682)"
			/>
			<path
				opacity="0.5"
				d="M1910.7 1955.2C1893.9 1978.1 1874.7 1999.1 1853.4 2017.9C1852.6 2018.7 1851.5 2019.6 1850.6 2020.5C1759 2091.5 1655.6 2145.7 1545.1 2180.7C1544.9 2180.7 1544.7 2180.7 1544.4 2180.9C1564.5 2239.9 1569.7 2334.1 1569.7 2334.1C1569.7 2334.1 1737.2 2291.3 1863 2150.3C1950.9 2051.7 2119.5 1811.7 1940.2 1495.5C1940.2 1495.5 1940.4 1496.5 1940.9 1497.8C1952 1519.9 1962.1 1542.5 1969.8 1565.8C2012.4 1693.3 1996.1 1837.1 1911 1954.9C1910.9 1955 1910.7 1955.2 1910.7 1955.2Z"
				fill="url(#paint14_linear_712_8682)"
			/>
			<path
				opacity="0.5"
				d="M308.9 1469.9C297.5 1443.9 288.8 1416.7 283.2 1388.8C283 1387.6 282.6 1386.2 282.4 1384.9C266.6 1269.6 271.7 1152.8 296.3 1040.3V1039.6C235.1 1027.6 151 984.8 151 984.8C151 984.8 104.3 1151.5 163.6 1330.7C205.1 1456.2 328.5 1722.2 691.9 1725C691.9 1725 690.9 1724.8 689.6 1724.3C665 1722.8 640.4 1720.3 616.3 1715.3C484.5 1688.3 368.3 1602.3 308.6 1469.7C308.6 1469.9 308.9 1469.9 308.9 1469.9Z"
				fill="url(#paint15_linear_712_8682)"
			/>
			<path
				opacity="0.6"
				d="M1477.7 813.4C1487.7 814.6 1497.6 815.1 1507.2 814.9C1507.2 814.9 1500.6 685.1 1484.7 618.3C1468.7 551.8 1445.1 507.5 1419.4 482.5C1400.8 464.5 1342.4 442.2 1297.1 579.6C1282.3 693.8 1363 798.4 1477.2 813.2C1477.4 813.2 1477.5 813.2 1477.7 813.3V813.4Z"
				fill="url(#paint16_linear_712_8682)"
			/>
			<path
				opacity="0.5"
				d="M757.9 1271.1C754 1262 749.5 1253.3 744.4 1244.8C744.4 1244.8 635.1 1315.4 585.4 1362.4C535.8 1409.5 509.2 1452.1 500.5 1486.9C494.3 1511.9 504.1 1573.6 645.8 1544.2C752.2 1499.8 802.3 1377.5 757.9 1271.1Z"
				fill="url(#paint17_linear_712_8682)"
			/>
			<path
				opacity="0.6"
				d="M1514.1 1665.4C1508.1 1673.3 1502.8 1681.9 1498.1 1690.4C1498.1 1690.4 1613.9 1749.7 1679.5 1769.2C1745.2 1788.7 1795.2 1790.4 1829.7 1780.5C1854.5 1773.5 1902.9 1733.9 1806.8 1626.1C1715.1 1556.2 1584.1 1573.9 1514.2 1665.6C1514.2 1665.6 1514.2 1665.7 1514.1 1665.7C1514.1 1665.6 1514.1 1665.4 1514.1 1665.4Z"
				fill="url(#paint18_linear_712_8682)"
			/>
			<path
				opacity="0.3"
				d="M1469.2 1126.9C1442.9 1214.2 1406.1 1293.6 1361 1363.5C1358.6 1367.1 1356.3 1370.8 1353.7 1374.6C1353.7 1374.6 1353.7 1374.8 1353.5 1375C1321.9 1420.4 1286.1 1462.8 1246.5 1501.5C1275.2 1531.9 1306 1561.4 1340 1589.4C1378.7 1619.8 1419.6 1647.3 1462.3 1671.5C1549.4 1581.7 1620.8 1477.8 1673.5 1364.3C1692.3 1325.9 1708.9 1286.4 1723.1 1246C1679.1 1213.7 1634.6 1187.8 1593.5 1170.3C1553 1153 1511.4 1138.5 1469 1126.9H1469.2Z"
				fill="url(#paint19_linear_712_8682)"
			/>
			<path
				opacity="0.3"
				d="M613.9 1991.2C850.9 2023.5 1078.9 1948.2 1234.3 1856C1215.2 1842.7 1196.4 1829 1177.8 1814.9C1118.7 1769.7 1064.5 1718.5 1016.1 1662C899.3 1713.1 752.1 1743 615.8 1715.2C484 1688.3 367.9 1602.3 308.2 1469.7C296.8 1443.7 288.2 1416.5 282.5 1388.6C317 1630.3 438.9 1841.2 613.7 1991.2H613.9Z"
				fill="url(#paint20_linear_712_8682)"
			/>
			<path
				opacity="0.3"
				d="M1246.5 1501.5C1186.6 1438.2 1135.9 1366.9 1095.9 1289.5C1094 1285.4 1091.8 1281.8 1089.9 1277.7V1277.3C1066.4 1227.2 1047.7 1174.9 1033.9 1121.3C993.2 1130.9 952.4 1142.9 911.3 1158.3C865.7 1176.5 821.5 1198.1 779.1 1222.9C817.2 1354.9 873.4 1466.4 939.1 1559.6C962.9 1594.9 988.6 1628.9 1016.6 1661.6C1066.6 1639.8 1111.4 1613.9 1147 1587.1C1182.1 1560.7 1215.4 1532 1246.7 1501.1C1246.7 1501.3 1246.5 1501.5 1246.5 1501.5Z"
				fill="url(#paint21_linear_712_8682)"
			/>
			<path
				opacity="0.3"
				d="M925.9 328.8C779.3 517.9 730.5 753 732.7 933.5C753.8 923.6 775.1 914.1 796.7 905.1C865.3 876.5 936.7 855.2 1009.7 841.6C1023.9 714.9 1071.5 572.5 1163.7 468.5C1252.9 367.7 1385.5 310.2 1530.2 325C1557.6 327.8 1586.9 334.6 1613.2 343.4C1614.4 343.8 1615.7 344.2 1616.8 344.4C1479.5 288.4 1331.2 264.6 1183.3 274.9C1093.5 281.1 1007.5 299.3 926.2 327.9C926 328.1 925.8 328.5 925.6 328.7H925.9V328.8Z"
				fill="url(#paint22_linear_712_8682)"
			/>
			<path
				opacity="0.3"
				d="M2209.8 1429.9C2119.1 1208.5 1939.8 1048.4 1782.4 960.1C1780.5 982.6 1778.2 1005.7 1774.9 1029.9C1765.4 1103.6 1748.1 1176.1 1723.4 1246.2C1826.1 1322 1925.8 1434.2 1969.9 1566.2C2012.4 1693.7 1996.2 1837.5 1911.1 1955.3C1894.3 1978.2 1875.1 1999.2 1853.8 2018L1853 2018.8C2036.5 1874.6 2166.3 1666.7 2210.9 1431.4C2210.9 1431 2210.5 1430.5 2210.5 1430.1L2209.8 1429.9Z"
				fill="url(#paint23_linear_712_8682)"
			/>
			<path
				opacity="0.3"
				d="M1009 992.2C1014.2 1035.8 1022.4 1079 1033.6 1121.4C1122.4 1100.4 1209.4 1092.7 1292.7 1096.8L1306 1097.4H1306.4C1358.6 1101.7 1412.9 1111.3 1469.2 1126.7C1481.2 1086.7 1491.2 1045.2 1498.5 1001.9C1506.4 948 1508.7 898.1 1508.5 854.7C1375.2 821.8 1250.7 815.1 1137.2 825.4C1094.5 828.2 1052 833.6 1009.9 841.4C1003.9 895.7 1003.7 947.3 1009.2 991.8C1009.2 992 1009 992.2 1009 992.2Z"
				fill="url(#paint24_linear_712_8682)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_712_8682"
					x1="396.92"
					y1="2103.03"
					x2="1990.64"
					y2="509.101"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#E6007A" />
					<stop offset="0.21" stopColor="#703AC2" />
					<stop offset="0.46" stopColor="#0070EB" />
					<stop offset="0.77" stopColor="#0297FB" />
					<stop offset="1" stopColor="#0AE2FF" />
				</linearGradient>
				<radialGradient
					id="paint1_radial_712_8682"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(1606.27 996.865) scale(475.337 475.337)"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="paint2_radial_712_8682"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(903.771 1878.64) scale(276.602 276.602)"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
				<linearGradient
					id="paint3_linear_712_8682"
					x1="488.723"
					y1="1831.83"
					x2="755.309"
					y2="1828.17"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<radialGradient
					id="paint4_radial_712_8682"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(852.738 1067.82) rotate(-120) scale(475.336 475.336)"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="paint5_radial_712_8682"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(1967.66 1235.39) rotate(-120) scale(276.601 276.601)"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
				<linearGradient
					id="paint6_linear_712_8682"
					x1="2134.29"
					y1="1618.15"
					x2="1997.83"
					y2="1389.15"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<radialGradient
					id="paint7_radial_712_8682"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(1268.34 1663) rotate(120) scale(475.337 475.337)"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
				<radialGradient
					id="paint8_radial_712_8682"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(878.436 635.893) rotate(120) scale(276.601 276.601)"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
				<linearGradient
					id="paint9_linear_712_8682"
					x1="1126.07"
					y1="299.58"
					x2="996.115"
					y2="532.373"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint10_linear_712_8682"
					x1="1184.45"
					y1="181.464"
					x2="777.119"
					y2="299.964"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint11_linear_712_8682"
					x1="414.861"
					y1="1734.56"
					x2="755.447"
					y2="2090.07"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint12_linear_712_8682"
					x1="2242.71"
					y1="1680.99"
					x2="2361.21"
					y2="1320.73"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint13_linear_712_8682"
					x1="1369.91"
					y1="387.539"
					x2="1915.88"
					y2="512.498"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint14_linear_712_8682"
					x1="1936.92"
					y1="1785.02"
					x2="1555.46"
					y2="2195.44"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint15_linear_712_8682"
					x1="443.002"
					y1="1577.6"
					x2="278.417"
					y2="1042.22"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint16_linear_712_8682"
					x1="1489.2"
					y1="588.835"
					x2="1316.58"
					y2="761.711"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint17_linear_712_8682"
					x1="557.824"
					y1="1373.24"
					x2="793.742"
					y2="1436.62"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint18_linear_712_8682"
					x1="1702.6"
					y1="1787.65"
					x2="1639.39"
					y2="1551.82"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint19_linear_712_8682"
					x1="1343.26"
					y1="1577.74"
					x2="1447.01"
					y2="1434.65"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint20_linear_712_8682"
					x1="986.556"
					y1="1515.77"
					x2="779.263"
					y2="1614.61"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint21_linear_712_8682"
					x1="911.507"
					y1="1170.67"
					x2="975.674"
					y2="1303.96"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint22_linear_712_8682"
					x1="1209.58"
					y1="759.241"
					x2="1165.28"
					y2="606.282"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint23_linear_712_8682"
					x1="1688.5"
					y1="1459.7"
					x2="1816.84"
					y2="1489.24"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint24_linear_712_8682"
					x1="1487.16"
					y1="1026.12"
					x2="1324.37"
					y2="996.579"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#231F20" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
			</defs>
		</svg>
	);
}
